import { bodyFontFamily, fontFamilyBackup, bodyFontSizeNumber } from 'dibs-sassy/exports/fonts.ts';
import { type IntlShape } from 'dibs-react-intl';

import { type SierraAPIConfig } from './types/SierraAPIConfig.ts';
import { type SupportChatTouchpoint, type SupportChatEndUserType } from '../types.ts';

const SIERRA_OPEN_CHAT_SESSION_STORAGE_KEY = 'SIERRA_OPEN_CHAT_SESSION';
const INACTIVITY_TIMEOUT_SECONDS = 60 * 10; // 10 minutes

const SIERRA_CONFIG: SierraAPIConfig = {
    display: 'corner',
    persistence: 'tab',
    hideOnClose: true,
    canEndConversation: true,
    canStartNewChat: true,
    showTimestamps: true,
    canPrintTranscript: true,
    autoDetectChatInterfaceStrings: true,
    inactivityTimeoutSeconds: INACTIVITY_TIMEOUT_SECONDS,
    typography: {
        fontFamily: `${bodyFontFamily}, ${fontFamilyBackup.body}`,
        fontSize: bodyFontSizeNumber.medium,
    },
    dimensions: {
        width: '400px',
        height: '620px',
    },
};

const SIERRA_PERSONA_MAP: Record<SupportChatTouchpoint, SupportChatEndUserType> = {
    Buyer_Messaging: 'buyer',
    Guest_Buyer_Messaging: 'buyer',
    Seller_Messaging: 'seller',
};

const SIERRA_LOCALE_MAP: Record<IntlShape['locale'], string> = {
    'en-US': 'en-US',
    'de-DE': 'de-DE',
    'fr-FR': 'fr-FR',
    'it-IT': 'it-IT',
    'es-001': 'es-ES',
    'en-PSEUDO': 'en-US',
    'en-DEBUG': 'en-US',
};

export {
    SIERRA_OPEN_CHAT_SESSION_STORAGE_KEY,
    SIERRA_CONFIG,
    SIERRA_PERSONA_MAP,
    SIERRA_LOCALE_MAP,
};
